webpackJsonp([212839066777427],{

/***/ 252:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {"use strict";
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(29);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Footer = __webpack_require__(46);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _Header = __webpack_require__(47);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _pageModule = __webpack_require__(53);
	
	var _pageModule2 = _interopRequireDefault(_pageModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var data = _ref.data;
	
	  return Glamor.createElement(
	    "div",
	    { className: _pageModule2.default.flex },
	    Glamor.createElement(_Header2.default, { color: "black" }),
	    Glamor.createElement(
	      "div",
	      { className: _pageModule2.default.page },
	      Glamor.createElement(
	        "h1",
	        null,
	        "My Blog"
	      ),
	      Glamor.createElement(
	        "h4",
	        { className: _pageModule2.default.blogPosts },
	        data.allMarkdownRemark.totalCount,
	        " Posts"
	      ),
	      data.allMarkdownRemark.edges.map(function (_ref2) {
	        var node = _ref2.node;
	        return Glamor.createElement(
	          "div",
	          { key: node.id },
	          Glamor.createElement(
	            _gatsbyLink2.default,
	            {
	              to: node.fields.slug,
	              css: { textDecoration: "none", color: "inherit" }
	            },
	            Glamor.createElement(
	              "h3",
	              { style: { marginBottom: 10 } },
	              node.frontmatter.title,
	              " ",
	              Glamor.createElement(
	                "span",
	                { className: _pageModule2.default.blogSpan },
	                "\u2014 ",
	                node.frontmatter.date
	              )
	            ),
	            Glamor.createElement(
	              "p",
	              null,
	              node.excerpt
	            )
	          ),
	          Glamor.createElement("br", null)
	        );
	      })
	    ),
	    Glamor.createElement(_Footer2.default, { color: "black" })
	  );
	};
	
	var query = exports.query = "** extracted graphql fragment **";
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9)))

/***/ }),

/***/ 53:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"flex":"src-pages----page-module---flex---HxH_T","page":"src-pages----page-module---page---vIddo","projectPage":"src-pages----page-module---projectPage---3Y-MS","projectPageTitle":"src-pages----page-module---projectPageTitle---2znlH","blogSpan":"src-pages----page-module---blogSpan---1wSvu","blogPosts":"src-pages----page-module---blogPosts---2e0Mn","projectContainer":"src-pages----page-module---projectContainer---Akwbh"};

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-blog-js-52bf5e9b1d33b2bccd28.js